// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute: React.FC<{ token: string | null; children: React.ReactElement }> = ({ token, children }) => {
  if (!token) return <Navigate to="/login" replace />;
  return children;
};
export default PrivateRoute;
